import React, { FC } from 'react'

import { Typography, FNOLButton, useTranslate, FNOLPageWrapper } from '@dg-shared'
import { CommonPageProps } from '../../../types/interface/fsm.interface'
import { Events } from '../../../FSM/shared/constants'
import { TRANSLATIONS as T } from '../../../constants'
import { useFNOLStyles } from '../shared/styles/useStyles'

const PageResponsible: FC<CommonPageProps> = ({ service, currentState }) => {
  const { t } = useTranslate(`${T.COLLISION}.responsible`)
  const { send } = service
  const FNOLClasses = useFNOLStyles({})

  const itemSelect = ({ eventName, label }: { eventName: Events; label: string }) => (
    <FNOLButton
      key={label}
      testId={label}
      handleClick={() => send({ type: eventName, state: currentState })}
      buttonText={t(label)}
    />
  )

  const eventItems = [
    { eventName: Events.FNOL_COLLISION_INJURED, label: 'buttons.yes' },
    { eventName: Events.FNOL_COLLISION_INJURED, label: 'buttons.no' },
  ]

  const ItemsList = () => <>{eventItems.map((item) => itemSelect(item))}</>

  const Content = () => (
    <>
      <Typography testId='title' type='h1' className={FNOLClasses.title}>
        {t('title')}
      </Typography>
      <Typography testId='subtitle' html={true} className={FNOLClasses.description}>
        {t('subtitle')}
      </Typography>
      <ItemsList />
    </>
  )

  return (
    <FNOLPageWrapper breadcrumbsBtnText={t(`${T.COMMON}/back`)} breadcrumbsStepPercentage={30}>
      <Content />
    </FNOLPageWrapper>
  )
}

export default PageResponsible
